// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ChatEntity__contents:not(.ChatEntity__contents--appPanel){border-radius:8px;background:rgba(70,70,70,.4);padding:4px 8px;margin-bottom:8px;overflow-wrap:break-word;font-size:14px;line-height:18px;color:#fff}`, ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
